<app-course-catalogue-details-card id="practical" i18n-label label="Practical">
  <div class="flex flex-col gap-5">
    <p i18n>This is what a camp day looks like:</p>

    <div>
      <h3 class="font-bold" i18n>Morning:</h3>
      <ul>
        @for (item of morningItems; track $index) {
          <li class="flex gap-4">
            <span class="min-w-12">{{ item.title }}</span>
            @if (item.description) {
              <span>{{ item.description }}</span>
            }
          </li>
        }
      </ul>
    </div>

    <div>
      <h3 class="font-bold" i18n>Afternoon:</h3>
      <ul>
        @for (item of dayItems; track $index) {
          <li class="flex gap-4">
            <span class="min-w-12">{{ item.title }}</span>
            @if (item.description) {
              <span>{{ item.description }}</span>
            }
          </li>
        }
      </ul>
    </div>

    <p class="text-sm text-slate-700" i18n>
      * Theme and game activities can also be interchanged as blocks, depending
      on the size of the group and the available materials. This is always
      clearly communicated to the children at the start of the week/day.
    </p>
  </div>
</app-course-catalogue-details-card>
